module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/PadpPromoCalc-6718116193c173f8c6f0c0b916176a0d.jpg";